import { PropsWithChildren, ReactNode } from 'react';
import Image from 'next/image';

import { Box, BoxProps } from '@chakra-ui/react';

import { ContentContainer } from './container';

export type BlueWaveHeroProps = PropsWithChildren<{ containerProps?: BoxProps; backgroundSlot?: ReactNode }>;

export function BlueWaveHero({
  children,
  containerProps,
  backgroundSlot = (
    <Box height='704px' left='50%' position='absolute' top='-50%' transform='translate(-50%, -50%)' width='2390px'>
      <Image
        alt=''
        quality={100}
        sizes='2390px'
        src='/images/backgrounds/blue-lines-wide.png'
        style={{
          objectFit: 'cover',
          objectPosition: 'center',
        }}
        fill
      />
    </Box>
  ),
}: BlueWaveHeroProps) {
  return (
    <Box
      as='section'
      backgroundColor='blue.800'
      color='white'
      display='flex'
      minHeight='176px'
      overflow='hidden'
      padding={{ base: 4, md: 0 }}
      position='relative'
      {...containerProps}
    >
      {backgroundSlot}
      <ContentContainer
        alignItems='center'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        position='relative'
      >
        {children}
      </ContentContainer>
    </Box>
  );
}
